import React from "react";
import Spinner from "./spinner";

const Callback = () => {
  return (
    <div style={{ margin: "2rem", textAlign: "center" }}>
      <Spinner />
    </div>
  );
};

export default Callback;
